import getEnvironDomain from "../utils/getEnvironDomain";
import initAxios from "./initAxios";

/** Запарно таскать baseUrl по компоннетам ради одного метода */
const baseUrl = getEnvironDomain();

class NotificationsApi {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
    this.axios = initAxios({ baseURL: apiUrl, withCredentials: true });
  }

  getUnreadCount = () =>
    this.axios.get("/v1.3/notifications/notification/simpleunreadcount");

  getUnarchived = (skip, count) => {
    const { token, cancel } = this.axios.source();
    const promise = this.axios.get(
      `/v1.3/notifications/notification/unarchived?skip=${skip}&count=${count}`,
      { cancelToken: token }
    );
    return { promise, cancel };
  };

  getArchived(skip, count) {
    const { token, cancel } = this.axios.source();
    const promise = this.axios.get(
      `/v1.3/notifications/notification/archived?skip=${skip}&count=${count}`,
      { cancelToken: token }
    );
    return { promise, cancel };
  }

  getById(id) {
    const { token, cancel } = this.axios.source();
    const promise = this.axios.put(
      "/v1.3/notifications/notification/getbyid",
      JSON.stringify(id),
      { cancelToken: token }
    );

    return { promise, cancel };
  }

  markAsRead = (ids) =>
    this.axios.post("/v1.3/notifications/archive", JSON.stringify(ids));

  markAllAsRead = () => this.axios.put("/v1.3/notifications/read");

  getUnreadImportantNtfs = (count, skip = 0) =>
    this.axios.get(
      `/v1.3/notifications/notification/unarchived?skip=${skip}&count=${count}&feedType=1`
    );

  readNtf = (id, deliveryId) =>
    this.axios.post("/v1.3/notifications/archive", [
      { ID: id, DeliveryId: deliveryId },
    ]);

  unsubscribe = (partnerId, notifyId) =>
    this.axios.post(
      `https://${baseUrl}/gw/rynda/webapi/v1/unsubscribe?partnerid=${partnerId}&ntfId=${notifyId}`
    );
}

export default NotificationsApi;
